/**
 * Ключ последней созданной задачи (DEV-2074).
 *
 * Плашку с ним показывает `App.vue` — одна на всё приложение: задачу заводят с
 * доски, из списка задач, из эпиков, из плана и из карточки родителя, и держать
 * в каждом экране свою плашку значит писать пять раз одно и то же. Экраны
 * только сообщают ключ, а «Открыть» уводит в карточку.
 */
import { ref } from 'vue'

/** Пусто — плашки нет; новый ключ показывает её заново */
export const createdIssueKey = ref('')

export const notifyIssueCreated = (key: string) => {
  createdIssueKey.value = key
}
